import { useEffect, useRef } from 'react'

interface UseTrackAvailableProgramsOnceArgs {
  /** True while the grid's care options are still loading; the event waits until this is false. */
  isLoading: boolean
  /** The available care options to report (AuroraCareOption values, assignable to string[]). */
  careOptions: string[]
  /** App-specific analytics callback that emits the FORKED_TRIAGE_AVAILABLE_PROGRAMS event. No-op when omitted. */
  trackAvailablePrograms?: (programs: string[]) => void
}

/**
 * Fires the "available programs" analytics event exactly once — when the care options have finished
 * loading. Used by `CareOptionsGrid` (Forked Triage v3) so the fire-once timing lives alongside the
 * grid, mirroring the logic from the v2 `ForkedTriagePage`.
 */
export const useTrackAvailableProgramsOnce = ({
  isLoading,
  careOptions,
  trackAvailablePrograms,
}: UseTrackAvailableProgramsOnceArgs) => {
  const hasTracked = useRef(false)
  useEffect(() => {
    if (!isLoading && !hasTracked.current && trackAvailablePrograms) {
      trackAvailablePrograms(careOptions)
      hasTracked.current = true
    }
  }, [isLoading, careOptions, trackAvailablePrograms])
}
